// extracted by mini-css-extract-plugin
export default {"paper":"LeftMenuCheckboxList_paper__gBD3P","activeButton":"LeftMenuCheckboxList_activeButton__iJP+e","inactiveButton":"LeftMenuCheckboxList_inactiveButton__bhdJv"};